import { render, staticRenderFns } from "./FolderPicker.vue?vue&type=template&id=6f8522d4&scoped=true&"
import script from "./FolderPicker.vue?vue&type=script&lang=js&"
export * from "./FolderPicker.vue?vue&type=script&lang=js&"
import style0 from "./FolderPicker.vue?vue&type=style&index=0&id=6f8522d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8522d4",
  null
  
)

export default component.exports